import Component from '@bythepixel/component-loader';
import LngLat from './lngLat';
import LngLatBounds from './lngLatBounds';

export default class LocationCard extends Component {
  static selector = '[comp-listing-card]'
  static DEFAULTS = {
    onClick: () => {},
    map: undefined,
    activeClass: 'active',
    test: 'asdf',
  };

  #map
  #marker
  #locationData = this.$container.dataset
  #latLng = new LngLat(this.#locationData.latitude, this.#locationData.longitude)
  #bounds = new LngLatBounds(this.#locationData.latitude, this.#locationData.longitude);

  constructor(mapEl, options, loaderInstance) {
    super(mapEl, options, loaderInstance);
    this.$setOptions(options, LocationCard.DEFAULTS);
    this.setMap();
    this.createMarker();
    this.events();
  }

  events() {
    this.$container.addEventListener('click', () => {
      this.highlight();
      this.$options.onClick();
      this.#map.flyTo(this.#latLng.get().lng, this.#latLng.get().lat);
    });
    this.#map.on('dragstart', () => {
      this.removeHighlight();
    });
    this.#map.on('dragend', () => {
      this.removeHighlight();
    });
    this.$subscribe('highlightCard', () => {
      this.removeHighlight();
    });
  }

  createMarker() {
    this.#marker = this.#map.addMarker(this.#locationData);
    this.#latLng = new LngLat(this.#locationData.latitude, this.#locationData.longitude);
    this.#bounds.add(this.#latLng.get());
    this.#marker.on('click', () => this.highlight(true));
  }

  setMap(map = this.$options.map) {
    this.#map = map;
  }

  highlight(scrollTo = false) {
    this.$publish('highlightCard');
    this.$container.classList.add(this.$options.activeClass);
    this.#map.fitBounds();
    this.#marker.highlight();
    if (scrollTo) {
      this.$container.scrollIntoView();
    }
    this.#map.flyTo(this.#latLng.get().lng, this.#latLng.get().lat);
  }

  removeHighlight() {
    this.$container.classList.remove(this.$options.activeClass);
    this.#marker.removeHighlight();
  }

  getMarker() {
    return this.#marker;
  }
}
